import { render, staticRenderFns } from "./MyProducts.vue?vue&type=template&id=1651d80c&"
import script from "./MyProducts.vue?vue&type=script&lang=ts&"
export * from "./MyProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports